/* Artegran Home - WhatsApp Help Popup (Premium)
   - Mostra após 30s
   - Só 1x por dia (localStorage)
   - Fecha ao clicar fora / no X / ESC
   - Botão abre WhatsApp
*/

(function () {
  const CONFIG = {
    delayMs: 5000, // 30s
    onceHours: 24, // 1x por 24h
    storageKey: "ag_whats_popup_last_seen",
    whatsappNumber: "554399890001", // sem +
    message:
      "Olá! Vim pelo site Artegran Home. Preciso de ajuda para escolher a peça ideal.",
    // Se quiser NÃO mostrar em algumas páginas, coloque partes do caminho aqui:
    excludePaths: ["/cart", "/checkout"],
  };

  const now = Date.now();

  // Não rodar em páginas excluídas
  try {
    const path = window.location.pathname || "/";
    if (CONFIG.excludePaths.some((p) => path.startsWith(p))) return;
  } catch (e) {}

  // 1x por período
  const lastSeen = Number(localStorage.getItem(CONFIG.storageKey) || "0");
  const cooldown = CONFIG.onceHours * 60 * 60 * 1000;
  if (lastSeen && now - lastSeen < cooldown) return;

  // Não abrir se já tem algum modal aberto (best effort)
  const hasShopifyModal = () =>
    document.querySelector(".modal__content, .drawer, details[open]");

  const openWhats = () => {
    const url =
      "https://wa.me/" +
      CONFIG.whatsappNumber +
      "?text=" +
      encodeURIComponent(CONFIG.message);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const build = () => {
    if (document.getElementById("agWhatsPopup")) return;

    const overlay = document.createElement("div");
    overlay.id = "agWhatsPopup";
    overlay.className = "agw";

    overlay.innerHTML = `
      <div class="agw__overlay" data-agw-close></div>

      <div class="agw__panel" role="dialog" aria-modal="true" aria-label="Atendimento via WhatsApp">
        <button class="agw__close" type="button" aria-label="Fechar" data-agw-close>
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path d="M18.3 5.7a1 1 0 0 0-1.4 0L12 10.6 7.1 5.7A1 1 0 1 0 5.7 7.1L10.6 12l-4.9 4.9a1 1 0 1 0 1.4 1.4L12 13.4l4.9 4.9a1 1 0 0 0 1.4-1.4L13.4 12l4.9-4.9a1 1 0 0 0 0-1.4z"></path>
          </svg>
        </button>

        <div class="agw__badge">Atendimento</div>

        <h3 class="agw__title">Precisa de ajuda para escolher a peça ideal?</h3>
        <p class="agw__text">
          Tiramos dúvidas sobre <strong>medidas, acabamento e prazos</strong>. Fale com um especialista no WhatsApp.
        </p>

        <div class="agw__actions">
          <button class="agw__btn agw__btn--primary" type="button" data-agw-whats>
            Falar com especialista
          </button>
          <button class="agw__btn agw__btn--ghost" type="button" data-agw-close>
            Agora não
          </button>
        </div>

        <p class="agw__hint">Resposta rápida • Atendimento humano</p>
      </div>
    `;

    document.body.appendChild(overlay);

    // Eventos
    const close = () => {
      overlay.classList.remove("is-open");
      document.documentElement.classList.remove("agw-lock");
      // marca como visto
      localStorage.setItem(CONFIG.storageKey, String(Date.now()));
      setTimeout(() => overlay.remove(), 160);
    };

    overlay.addEventListener("click", (e) => {
      const t = e.target;
      if (t && t.closest && t.closest("[data-agw-close]")) close();
      if (t && t.closest && t.closest("[data-agw-whats]")) {
        localStorage.setItem(CONFIG.storageKey, String(Date.now()));
        openWhats();
        close();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });

    // abrir com animação
    requestAnimationFrame(() => {
      overlay.classList.add("is-open");
      document.documentElement.classList.add("agw-lock");
    });
  };

  const injectCSS = () => {
    if (document.getElementById("agwStyles")) return;

    const style = document.createElement("style");
    style.id = "agwStyles";
    style.textContent = `
      .agw{ position:fixed; inset:0; z-index:99998; display:block; }
      .agw__overlay{
        position:absolute; inset:0;
        background: rgba(0,0,0,.35);
        opacity:0; transition: opacity .18s ease;
      }
      .agw__panel{
        position:absolute;
        right: 22px; bottom: 92px;
        width: min(420px, calc(100vw - 32px));
        background: rgba(255,255,255,.78);
        border: 1px solid rgba(0,0,0,.08);
        border-radius: 18px;
        box-shadow: 0 30px 90px rgba(0,0,0,.22);
        backdrop-filter: blur(14px);
        -webkit-backdrop-filter: blur(14px);
        padding: 18px 18px 14px;
        transform: translateY(10px);
        opacity: 0;
        transition: transform .18s ease, opacity .18s ease;
        font-family: var(--font-body-family, system-ui);
        color: rgba(10,10,10,.92);
      }
      .agw.is-open .agw__overlay{ opacity:1; }
      .agw.is-open .agw__panel{ opacity:1; transform: translateY(0); }

      .agw__close{
        position:absolute; top: 10px; right: 10px;
        width: 36px; height: 36px;
        border-radius: 999px;
        border: 1px solid rgba(0,0,0,.08);
        background: rgba(255,255,255,.7);
        display:grid; place-items:center;
        cursor:pointer;
      }
      .agw__close svg{ fill: rgba(0,0,0,.65); }

      .agw__badge{
        display:inline-block;
        font-size: 12px;
        letter-spacing: .08em;
        text-transform: uppercase;
        padding: 6px 10px;
        border-radius: 999px;
        background: rgba(10,10,10,.06);
        border: 1px solid rgba(0,0,0,.06);
        margin-bottom: 10px;
      }
      .agw__title{
        margin: 0 0 8px;
        font-size: 18px;
        line-height: 1.2;
        font-weight: 650;
      }
      .agw__text{
        margin: 0 0 14px;
        font-size: 14px;
        line-height: 1.5;
        color: rgba(10,10,10,.76);
      }
      .agw__actions{
        display:flex; gap: 10px; flex-wrap: wrap;
      }
      .agw__btn{
        border-radius: 12px;
        padding: 12px 14px;
        font-size: 14px;
        border: 1px solid rgba(0,0,0,.10);
        background: rgba(255,255,255,.55);
        cursor: pointer;
        transition: transform .15s ease, box-shadow .15s ease, background .15s ease;
      }
      .agw__btn:hover{ transform: translateY(-1px); box-shadow: 0 12px 30px rgba(0,0,0,.12); }

      .agw__btn--primary{
        background: rgba(15,15,15,.90);
        color: #fff;
        border-color: rgba(255,255,255,.12);
      }
      .agw__btn--primary:hover{ background: rgba(15,15,15,1); }

      .agw__btn--ghost{
        background: rgba(255,255,255,.35);
        color: rgba(10,10,10,.78);
      }

      .agw__hint{
        margin: 12px 0 0;
        font-size: 12px;
        color: rgba(10,10,10,.55);
      }

      .agw-lock body{ overflow:hidden; }

      @media (max-width: 749px){
        .agw__panel{
          left: 16px; right: 16px;
          bottom: 86px;
          width: auto;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const start = () => {
    if (hasShopifyModal()) return; // se tem modal aberto, não atrapalha
    injectCSS();
    build();
  };

  // espera delay
  window.setTimeout(start, CONFIG.delayMs);
})();
